// The app's backend facade. Import it as
//   import { api } from '@/api/client'
//
// It stands where `base44` used to, exposing the same entities / auth /
// functions / integrations shape over Supabase so the migration did not have
// to rewrite every call site in one change. See
// docs/migration-to-supabase.md §9.
//
// New code is free to import { supabase } from '@/api/supabaseClient' and use
// PostgREST directly; this facade exists to be retired gradually.

import { entities } from '@/api/entities';
import { auth } from '@/api/auth';
import { functions } from '@/api/functions';
import { integrations, storage } from '@/api/storage';

export const api = { entities, auth, functions, integrations, storage };

export { entities, auth, functions, integrations, storage };
export { EMAIL_ALREADY_REGISTERED } from '@/api/auth';
export { supabase } from '@/api/supabaseClient';
